<template>
  <div class="toolBar" v-if="showToolbar">
    <template v-for="item in items" :key="item.name">
      <template v-if="item.name === 'exportResults'">
        <button class="borderless" @click="item.fn">
          <IconFileSpreadsheet stroke="1" color="var(--primary)" size="21" />
        </button>
      </template>
      <template v-if="item.name === 'columnSettings'">
        <button class="borderless" @click="item.fn">
          <IconEyeCog stroke="1" color="var(--primary)" size="21" />
        </button>
      </template>
    </template>

    <div class="zoom">
      <button class="zoom borderless" @click="zoomOut()">
        <IconZoomOut stroke="1.25" size="20" color="var(--primary)" />
      </button>
      <button class="zoom borderless" @click="zoomIn()">
        <IconZoomIn stroke="1.25" size="20" color="var(--primary)" />
      </button>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { IconZoomIn } from '@tabler/icons-vue'
import { IconZoomOut } from '@tabler/icons-vue'
import { IconFileSpreadsheet } from '@tabler/icons-vue'
import { IconEyeCog } from '@tabler/icons-vue'

export default {
  name: 'ToolBar',
  data() {
    return {
      fontSize: null,
    }
  },
  components: { IconZoomIn, IconZoomOut, IconFileSpreadsheet, IconEyeCog },
  computed: {
    ...mapState({
      items: (state) => state.toolbar.items,
    }),
    showToolbar() {
      let showToolbar = true
      if (['unpaidSingle'].includes(this.$route.name)) {
        showToolbar = false
      }
      return showToolbar
    },
    userRole() {
      if (typeof this.$store.state.auth.jwt.CustomUserInfo === 'undefined') {
        return null
      }
      return this.$store.state.auth.jwt.CustomUserInfo.Role
    },
  },
  methods: {
    ...mapActions({
      setTablesNeedRefresh: 'toolbar/tablesNeedRefresh',
    }),
    zoomIn() {
      const fontValue = parseFloat(this.fontSize.match(/\d+/)[0])
      const fontUnit = this.fontSize.match(/\D+/)[0]
      const newSize = fontValue + 1

      this.setFontSize(newSize, fontUnit)
      this.setTablesNeedRefresh(true)
    },

    zoomOut() {
      const fontValue = parseFloat(this.fontSize.match(/\d+/)[0])
      const fontUnit = this.fontSize.match(/\D+/)[0]
      const newSize = fontValue - 1

      this.setFontSize(newSize, fontUnit)
      this.setTablesNeedRefresh(true)
    },

    setFontSize(value, unit) {
      if (value > 11 && value < 20) {
        const size = value + unit
        const root = document.documentElement
        root.style.setProperty('--main-font-size', size)
        this.fontSize = size
        localStorage.setItem('fontSize', size)
      }
    },
  },
  created() {
    const root = document.documentElement
    const style = getComputedStyle(root)
    this.fontSize = style.getPropertyValue('--main-font-size')
    const savedSize = localStorage.getItem('fontSize')
    if (savedSize !== null) {
      const fontValue = parseFloat(savedSize.match(/\d+/)[0])
      const fontUnit = savedSize.match(/\D+/)[0]
      this.setFontSize(fontValue, fontUnit)
    }
  },
}
</script>

<style scoped lang="scss">
.toolBar {
  padding-top: 3px;
  margin-right: 3px;
  display: flex;
  gap: calc(var(--sp) * 0.75);
  flex-grow: 1;
  justify-content: flex-end;
}
.zoom {
  display: flex;
  gap: calc(var(--sp) * 0.25);
  justify-content: flex-end;
  margin-top: 2px;
}
button:hover::before {
  background-color: transparent !important;
}

button {
  margin: 0;
  height: 30px !important;
  min-height: unset !important;
  padding: 0 !important;
  min-width: fit-content;
}
</style>
